import TemplateView from '../TemplateView'

export class Option extends TemplateView {
    constructor({
        onSelected = () => {},
        additionalClass = '',
    }) {
        super()

        this.state = {
            title: '',
            isLoading: false
        }

        this.callbacks = {
            onSelected
        }

        this.params = {
            additionalClass,
        }

        this.onStatePropertyChanged('title', (title) => {
            this.$title.text(title)
        })

        this.onStatePropertyChanged('isLoading', (isLoading) => {
            this.$el.find('.disableOverlay').toggle(isLoading)
            if (isLoading)
                this.$el.addClass('disabled')
            else
                this.$el.removeClass('disabled')
        })
    }

    templateHtml() {
        return "  <div class='option <%-additionalClass%>'>" +
               "    <div class='icon'></div>" +
               "    <div class='title'></div>" +
               "    <div class='disableOverlay'></div>" +
               "  </div>"
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }

    afterRender() {
        this.$title = this.find('.title')

        this.$el.click((e) => {
            e.stopPropagation()
            this.callbacks.onSelected()
        })
    }
}


export default class SimpleMenu extends TemplateView {
    constructor({
        additionalClass = '',
    } = {}) {
        super()

        this.params = {
            additionalClass,
        }
    }

    templateHtml() {
        return "<div class='components_simpleMenu <%-additionalClass%>'></div>"
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/components/SimpleMenu.js